import type { MultipleQueriesResponse } from '@algolia/client-search'
import dayjs from 'dayjs'
import { HITS_PER_SHOWCASE } from './algolia/constants'
import type { AlgoliaEventItem } from '~/composables/types/algolia'

export const useHomepageAlgolia = async () => {
  const searchClient = useAlgoliaRef()
  const { locale } = useI18n()

  const todayInSecs = dayjs().unix()
  const sevenDaysLaterInSecs = dayjs()
    .add(7, 'day')
    .set('hour', 23)
    .set('minute', 59)
    .set('second', 0)
    .set('millisecond', 0)
    .unix()

  const homePageQueryParams = [
    {
      indexName: getTopEventListIndexName(locale.value),
      hitsPerPage: HITS_PER_SHOWCASE,
      filters: `dates_ts:${todayInSecs} TO ${sevenDaysLaterInSecs} OR dates_private_ts:${todayInSecs} TO ${sevenDaysLaterInSecs}`,
      isBoxes: false,
    },
    {
      indexName: getEventListSortByDateDescIndexName(locale.value),
      hitsPerPage: HITS_PER_SHOWCASE,
      isBoxes: false,
    },
    {
      indexName: getTopGiftIdeasIndexName(locale.value),
      hitsPerPage: HITS_PER_SHOWCASE * 2,
      isBoxes: false,
    },
    {
      indexName: getEventListIndexName(locale.value),
      filters: '(has_promotions:true)',
      hitsPerPage: HITS_PER_SHOWCASE,
      isBoxes: false,
    },
    {
      indexName: getBoxesIndexName(locale.value),
      hitsPerPage: HITS_PER_SHOWCASE,
      isBoxes: true,
    },
  ]

  const homePageQueries = homePageQueryParams.map((params) => {
    let filters = params.isBoxes ? '' : 'has_events:true'
    delete params.isBoxes

    if (params.filters) {
      filters += ` AND (${params.filters})`
    }

    return {
      ...params,
      clickAnalytics: true,
      filters,
      aroundLatLngViaIP: process.client,
      aroundRadius: 'all',
      aroundPrecision: [
        { from: 0, value: 15000 },
        { from: 30000, value: 30000 },
        { from: 150000, value: 100000 },
      ],
    }
  })

  const {
    data: algoliaResults,
    pending,
    status,
  } = await useLazyAsyncData<MultipleQueriesResponse<AlgoliaEventItem>>(
    `algoliaResults-homepage-${process.client}`,
    () => {
      return searchClient.search(homePageQueries)
    }
  )

  return {
    algoliaResults,
    pending,
    status,
  }
}
